import { Environments } from '@innovyze/stylovyze';

import { formatUrlTrailing } from '@Utils/urlFormatting';
import { axiosWithHeaders, getService } from '@innovyze/lib_get_service';
import config from './config.api';

// See comments in package.md wrt eslint-disable-line below
const apiEnv =
	(localStorage.getItem('apiEnv') as keyof typeof Environments) || undefined; // eslint-disable-line

export const riskBaseUrl = formatUrlTrailing(
	getService('amRisk', config, apiEnv),
);

const riskService = axiosWithHeaders({
	config,
	service: 'amRisk',
	axiosCreateOpts: {
		timeout: 15000,
	},
});

export default riskService;
